import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AiOutlineClockCircle } from 'react-icons/ai';
import { BiDish } from 'react-icons/bi';
import { GiForkKnifeSpoon } from 'react-icons/gi';
import './styles.sass';
import clsx from 'clsx';

const useStyles = makeStyles({
    container: {
        '&&': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        }
    },
    text: {
        '&&': {
            fontFamily: `'Rubik', sans-serif`,
            color: 'white'
        }
    },
    move: {
        transform: 'translateY(-3px)'
    }
});

const Detail = ({ value, type }) => {
    const classes = useStyles();

    const renderIcon = () => {
        switch (type) {
            case 'time':
                return (
                    <AiOutlineClockCircle className="icon time" />
                );
            case 'quantity':
                return (
                    <BiDish className="icon quantity" />
                );
            case 'category':
                return (
                    <GiForkKnifeSpoon className="icon category" />
                );
            default:
                return null;
        }
    }

    return (
        <div className={classes.container}>
            <div>{renderIcon()}</div>
            <Typography
                className={clsx(classes.text, type === 'quantity' && classes.move)}
            >
                {value}
            </Typography>
        </div>
    )
}

export default Detail;